function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  'use strict';

  function init($q, Resource) {
    var s = {};
    freshState();
    function freshState() {
      s.filters = {};
      s.categories = {};
      s._filters_promise = null;
      s._categories_promise = null;
      s._resource = new Resource('/filters', false, true);
    }
    return [s, freshState];
  }
  angular.module('wsLrs.services').factory('FilterRegistry', ['$http', '$q', '$rootScope', 'Api', 'AppPermissions', 'Resource', function ($http, $q, $rootScope, Api, AppPermissions, Resource) {
    var _init = init($q, Resource),
      _init2 = _slicedToArray(_init, 2),
      res = _init2[0],
      freshState = _init2[1];
    $rootScope.$on('organization-selected', freshState);
    res.clear = function clear() {
      res.filters = {};
      res.categories = {};
      res._filters_promise = null;
    };
    res.removeFilter = function removeFilter(filter) {
      res.clear();
      delete res.filters[filter.id];
    };
    function addFilter(filter) {
      var config = _.extend({
        id: filter.id
      }, filter.config);
      var customFilter = _.extend({
        id: filter.id
      }, filter, {
        config: config
      });
      res.filters[filter.id] = customFilter;
    }
    function addFilterCategory(filterCategory) {
      var category = _.extend({
        id: filterCategory.id
      }, filterCategory);
      res.categories[filterCategory.id] = category;
    }
    res.add = function add(x) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$_type = _ref._type,
        _type = _ref$_type === void 0 ? 'filter' : _ref$_type;
      if (_type === 'filter') {
        addFilter(x);
      }
      if (_type === 'category') {
        addFilterCategory(x);
      }
    };
    function getFilter(filterId) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$includeMetaData = _ref2.includeMetaData,
        includeMetaData = _ref2$includeMetaData === void 0 ? false : _ref2$includeMetaData;
      var filter = res.filters[filterId];
      if (typeof filter !== 'undefined') {
        return includeMetaData ? filter : filter.config;
      }
    }
    function getFilterCategory(categoryId) {
      return res.categories[categoryId];
    }
    res.get = function get(id) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$_type = _ref3._type,
        _type = _ref3$_type === void 0 ? 'filter' : _ref3$_type,
        _ref3$includeMetaData = _ref3.includeMetaData,
        includeMetaData = _ref3$includeMetaData === void 0 ? false : _ref3$includeMetaData;
      if (_type === 'filter') {
        return getFilter(id, {
          includeMetaData: includeMetaData
        });
      }
      if (_type === 'category') {
        return getFilterCategory(id);
      }
    };
    function getAllFilters() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$includeMetaData = _ref4.includeMetaData,
        includeMetaData = _ref4$includeMetaData === void 0 ? false : _ref4$includeMetaData;
      return Object.keys(res.filters).map(function (filterId) {
        return res.get(filterId, {
          includeMetaData: includeMetaData
        });
      }).filter(function (x) {
        return typeof x !== 'undefined';
      });
    }
    function getAllFilterCategories() {
      return Object.keys(res.categories).map(function (categoryId) {
        return res.get(categoryId, {
          _type: 'category'
        });
      }).filter(function (x) {
        return typeof x !== 'undefined';
      });
    }
    res.getAll = function getAll() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$_type = _ref5._type,
        _type = _ref5$_type === void 0 ? 'filter' : _ref5$_type,
        _ref5$includeMetaData = _ref5.includeMetaData,
        includeMetaData = _ref5$includeMetaData === void 0 ? false : _ref5$includeMetaData,
        _ref5$includeFilterCa = _ref5.includeFilterCategories,
        includeFilterCategories = _ref5$includeFilterCa === void 0 ? false : _ref5$includeFilterCa;
      if (_type === 'filter' && includeFilterCategories) {
        return {
          filters: getAllFilters({
            includeMetaData: includeMetaData
          }),
          categories: getAllFilterCategories()
        };
      }
      if (_type === 'filter') {
        return getAllFilters({
          includeMetaData: includeMetaData
        });
      }
      if (_type === 'category') {
        return getAllFilterCategories();
      }
    };
    function hasFilter(filterId) {
      return res.filters.hasOwnProperty(filterId);
    }
    function hasFilterCategory(categoryId) {
      return res.categories.hasOwnProperty(categoryId);
    }
    res.has = function has(id) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$_type = _ref6._type,
        _type = _ref6$_type === void 0 ? 'filter' : _ref6$_type;
      if (_type === 'filter') {
        hasFilter(id);
      }
      if (_type === 'category') {
        hasFilterCategory(id);
      }
    };
    res.prepareFilters = function prepareFilters() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$includeFilterCa = _ref7.includeFilterCategories,
        includeFilterCategories = _ref7$includeFilterCa === void 0 ? false : _ref7$includeFilterCa;
      try {
        if (!res._filters_promise) {
          res._filters_promise = res._resource.getAll({
            showHidden: true
          }).then(function (filters) {
            return angular.forEach(filters, function (f) {
              return res.add(f);
            });
          });
        }
        if (includeFilterCategories) {
          return $q.all([res._filters_promise, prepareFilterCategories()]);
        }
        return res._filters_promise;
      } catch (e) {
        return $q.reject(e);
      }
    };
    function prepareFilterCategories() {
      try {
        if (!res._categories_promise) {
          res._categories_promise = $http.get(Api.url("/filter-categories")).then(function (_ref8) {
            var categories = _ref8.data.results;
            return categories;
          }).then(function (categories) {
            return angular.forEach(categories, function (c) {
              return res.add(c, {
                _type: 'category'
              });
            });
          });
        }
        return res._categories_promise;
      } catch (e) {
        return $q.reject(e);
      }
    }
    res.setCustomFiltersOnCard = function setCustomFiltersOnCard(card) {
      if (card.configuration && card.configuration.customFilters) {
        card.configuration.customFilters = card.configuration.customFilters.map(function (f) {
          if (typeof f.id === 'undefined') {
            return f;
          }
          return res.get(f.id) || f;
        });
      }
    };
    return res;
  }]);
})();
